import React from 'react';
import { Button } from 'react-bootstrap';
import { BsArchiveFill } from 'react-icons/bs';
import { ARCHIVE_TOOLTIP } from 'utils/constants';
import classnames from 'classnames';

interface IArchiveRequestButton {
  archivingInProgress: boolean;
  isSubmittedByCurrUser: boolean;
  isSearchInEditingAndSubmittable: boolean;
  onClick: () => void;
}

export const ArchiveRequestButton = ({
  archivingInProgress,
  isSubmittedByCurrUser,
  isSearchInEditingAndSubmittable,
  onClick,
}: IArchiveRequestButton) => {
  return (
    <Button
      className={classnames('mr-2', 'btn btn-secondary-dark', 'editBtn')}
      variant="secondary"
      onClick={onClick}
      title={ARCHIVE_TOOLTIP}
      disabled={archivingInProgress || !isSubmittedByCurrUser}
      data-cy={'archive-request:archive-request-button'}
    >
      <BsArchiveFill className="mr-2" size={'1.3em'} />
      {isSearchInEditingAndSubmittable ? 'Archive' : 'Archive Request'}
    </Button>
  );
};
